import { render } from "./VectorChurch.vue?vue&type=template&id=a8eb1f10"
import script from "./VectorChurch.vue?vue&type=script&lang=js"
export * from "./VectorChurch.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__